export default __webpack_public_path__ + "static/media/tmvc-house.01ae1d3e.svg";